// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 2H2V11H11V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H13V11H22V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 13H2V22H11V13Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18.5 12.9999H16.5V16.5H13V18.5H16.5V22H18.5V18.5H22V16.5H18.5V12.9999Z"}}]};

const GridAddFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'grid-add-filled',
    ref,
    icon: element,
  },
));

GridAddFilledIcon.displayName = 'GridAddFilledIcon';

export default GridAddFilledIcon;
